import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme/constants';
import { CVC, EXPIRY, NAME, NUMBER } from '../../constants/field-names';
export var FormGrid = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-areas: '", " ", "' '", " ", "' '", " ", "';\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto;\n  grid-column-gap: ", "px;\n  grid-row-gap: ", "px;\n"])), NUMBER, NUMBER, NAME, NAME, EXPIRY, CVC, gridSize() * 2, gridSize() * 2);